import { render, staticRenderFns } from "./LKPublicationsFormdataTableInput.vue?vue&type=template&id=967575ae&"
import script from "./LKPublicationsFormdataTableInput.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsFormdataTableInput.vue?vue&type=script&lang=js&"
import style0 from "./LKPublicationsFormdataTableInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports